import { render } from "./momoOnBanque.vue?vue&type=template&id=5d32d902&scoped=true"
import script from "./momoOnBanque.vue?vue&type=script&lang=js"
export * from "./momoOnBanque.vue?vue&type=script&lang=js"

import "./momoOnBanque.vue?vue&type=style&index=0&id=5d32d902&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d32d902"]])

export default __exports__